/**
 * @file payIdempotency.js
 * @description 支付预下单幂等键
 * @module shared/utils/payIdempotency
 */

/**
 * 生成支付幂等键（建议 UUID）
 * @returns {string}
 */
export function createPayIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `pay-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
}
